import React from "react";

const SavvycalIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_864)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20.6251,
  cy: 20.6252,
  r: 14.3751,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6127 0.887586C31.9379 -1.81244 36.3529 1.15884 39.0779 16.6202C41.8042 32.0804 39.0304 36.3204 23.349 39.0867C7.66638 41.8505 3.61133 38.8204 0.883808 23.3553C-1.84247 7.89015 1.29006 3.59136 16.614 0.887586H16.6127ZM18.379 7.7189C15.4452 8.23641 13.3239 9.58392 12.1039 11.5414C11.1452 13.079 10.8402 14.8802 11.1164 16.339C11.7277 19.5553 14.3827 21.5803 19.7627 21.989L20.1827 22.019L20.6002 22.0528L20.9978 22.0903C22.8728 22.2778 24.0728 22.5965 24.7353 23.0065C25.1778 23.279 25.3553 23.5766 25.4815 24.2978C25.7228 25.6666 24.6565 26.9066 21.849 27.4016C19.9927 27.7291 18.0115 27.3353 15.8452 26.1541C15.5749 26.0067 15.2783 25.9141 14.9722 25.8814C14.6661 25.8487 14.3566 25.8767 14.0613 25.9636C13.766 26.0505 13.4907 26.1948 13.2512 26.3881C13.0116 26.5814 12.8125 26.8201 12.6652 27.0903C12.5178 27.3606 12.4252 27.6573 12.3925 27.9634C12.3598 28.2694 12.3878 28.579 12.4747 28.8743C12.5616 29.1695 12.7059 29.4448 12.8992 29.6844C13.0925 29.9239 13.3312 30.123 13.6014 30.2704C16.6577 31.9366 19.7002 32.5416 22.664 32.0191C27.8378 31.1066 30.8303 27.6316 30.0991 23.4841C29.4041 19.5453 26.6266 17.7877 20.499 17.3415L20.0952 17.3127C18.1215 17.1615 16.8865 16.7777 16.234 16.2902C15.9115 16.0477 15.7927 15.834 15.7214 15.4652C15.6602 15.1365 15.7627 14.534 16.0815 14.0215C16.5715 13.2365 17.5265 12.6302 19.194 12.3364C20.6715 12.0752 22.1003 12.3264 23.564 13.1215C23.8345 13.2685 24.1312 13.3607 24.4373 13.3931C24.7434 13.4254 25.0529 13.3971 25.3481 13.3098C25.6433 13.2225 25.9184 13.0779 26.1577 12.8843C26.397 12.6907 26.5958 12.4519 26.7428 12.1814C26.8898 11.911 26.9821 11.6143 27.0144 11.3081C27.0467 11.002 27.0184 10.6925 26.9312 10.3974C26.8439 10.1022 26.6993 9.8271 26.5057 9.5878C26.3121 9.34849 26.0732 9.14966 25.8028 9.00266C23.424 7.7089 20.9215 7.27015 18.379 7.7189Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_864"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SavvycalIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;